import { debounce } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const subscribeProperty = (callback, node, property, delay = 100) => {
  const optimized = debounce(callback, delay);
  let prevValue = node[property];
  const id = setInterval(() => {
    const value = node[property];
    if (prevValue === value) {
      return;
    }
    optimized(value);
    prevValue = value;
  }, 50);
  return () => clearInterval(id);
};
